import React, { useState, useEffect } from 'react'
import { blindShuffle } from '../utils/SmartLabelUtils'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import 'katex/dist/katex.min.css'
import { InlineMath } from 'react-katex'
import { ComponentQuestion } from '../UIUtilsFiles/ComponentQuestion'

function MultipleChoiceText(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onValueChange,
    onAttemptChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isEmbeded,
    followTheFlow,
    onPriorityChange,
    handleSucAndFailFeedback,
    handleAiFeedback,
    controlDimension = {
      heightPx: 50,
      widthPx: 100
    },
    isCanvas
  } = props

  const ABCDE = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
  ]

  const {
    ControlID,
    DisplayType,
    AnswerType,
    Options,
    Answers,
    Score,
    AnswerColorFill,
    AnswerFontSize,
    SelectionColor,
    AnswerFillColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    Priority,
    TextAlign,
    FontStyle,
    Italic,
    Bold,
    QuestionText,
    QuestionFontSize,
    FeedbackOptions,
    OptionsAudioData
  } = mcData

  const [value, setValue] = useState('')
  const [sortedChoiceValueArray, setSortedChoiceValueArray] = useState([])

  useEffect(() => {
    if (defaultValue && defaultValue !== '') {
      if (defaultValue.CtlSortedArray) {
        setSortedChoiceValueArray(defaultValue.CtlSortedArray)
      } else {
        setSortedChoiceValueArray(blindShuffle(Options))
      }
    } else {
      setSortedChoiceValueArray(blindShuffle(Options))
    }
    if (defaultValue) {
      if (defaultValue.CtlValue) {
        let defaultValueSelected = defaultValue.CtlValue
        setValue(defaultValueSelected)
      }
    } else {
      setValue('')
    }
  }, [defaultValue])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, value)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    if (value === correctAnswer) {
      onExplanationVisible(true, CorrectAnswerExplanation)
    } else {
      onExplanationVisible(false, IncorrectAnswerExplanation)
    }
  }

  // function handleFeedbackText(optionValue, feedbackStatus) {
  //   let selectedOptionIndex = Options.findIndex(
  //     (optionItem) => optionItem.Option === optionValue
  //   )
  //   if (DisplayType === 'radioButton') {
  //     if (FeedbackOptions && FeedbackOptions[selectedOptionIndex]) {
  //       let currentFeedbackText = FeedbackOptions[selectedOptionIndex]
  //       handleAiFeedback(currentFeedbackText, feedbackStatus)
  //     } else {
  //       let currentFeedbackText = FeedbackOptions[selectedOptionIndex]
  //       handleAiFeedback('', feedbackStatus)
  //     }
  //   } else {
  //     handleSucAndFailFeedback(feedbackStatus)
  //   }
  // }

  function handleFeedbackText(optionValue, feedbackStatus) {
    let selectedOptionIndex = Options.findIndex(
      (optionItem) => optionItem.Option === optionValue
    )
    if (DisplayType === 'radioButton') {
      if (
        OptionsAudioData &&
        OptionsAudioData.optionsAudioLinks[selectedOptionIndex]
      ) {
        let currentFeedbackText = {}
        if (feedbackStatus) {
          let currentData = {
            successAudioLink: '',
            successFeedback: ''
          }
          currentData.successAudioLink =
            OptionsAudioData.optionsAudioLinks[selectedOptionIndex]
          currentData.successFeedback =
            OptionsAudioData.optionsData[selectedOptionIndex]
          currentFeedbackText = currentData
        } else {
          let currentData = {
            failureAudioLink: '',
            failureFeedback: ''
          }
          currentData.failureAudioLink =
            OptionsAudioData.optionsAudioLinks[selectedOptionIndex]
          currentData.failureFeedback =
            OptionsAudioData.optionsData[selectedOptionIndex]
          currentFeedbackText = currentData
        }
        handleSucAndFailFeedback(feedbackStatus, currentFeedbackText)
      } else {
        if (!isPractice && isEmbeded) {
          onPriorityChange(Priority)
        }
      }
    }
  }

  function handleOptionChange(optionValue) {
    onAttemptChange(1)
    setValue(optionValue)
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    if (optionValue === correctAnswer) {
      handleSuccessChange(true)
    } else {
      handleSuccessChange(false)
    }
    validateCorrectAnswer(false, optionValue)
  }

  function validateCorrectAnswer(timerValue, optionValue) {
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    if (isPractice) {
      if (optionValue === correctAnswer) {
        if (followTheFlow) {
          handleFeedbackText(optionValue, true)
        } else {
          if (isEmbeded) {
            onPriorityChange(Priority)
          }
        }
      } else {
        if (followTheFlow) {
          handleFeedbackText(optionValue, false)
        }
      }
    } else {
      if (isEmbeded) {
        onPriorityChange(Priority)
      }
    }

    if (optionValue === correctAnswer) {
      onValueChange(
        ControlID,
        optionValue,
        Score,
        Score,
        sortedChoiceValueArray,
        timerValue
      )
    } else {
      onValueChange(
        ControlID,
        optionValue,
        0,
        Score,
        sortedChoiceValueArray,
        timerValue
      )
    }
  }

  return (
    <div
      className='slide-comp-wrapper'
      style={{ overflow: 'hidden' }}
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
    >
      {isEmbeded && QuestionText && (
        <ComponentQuestion
          QuestionText={QuestionText}
          FontStyle={FontStyle}
          Italic={Italic}
          Bold={Bold}
          QuestionFontSize={QuestionFontSize}
        />
      )}
      {sortedChoiceValueArray &&
        sortedChoiceValueArray.map((item, index) => {
          const totalHeight = isEmbeded ? controlDimension.heightPx : 40
          const cardRowHeight = totalHeight / sortedChoiceValueArray.length
          return (
            <div
              key={index.toString()}
              style={{
                width: isEmbeded ? '100%' : '60%',
                height: isCanvas ? '50px' : cardRowHeight + '%',
                display: 'flex',
                flexDirection: 'row',
                fontSize:
                  AnswerFontSize === 'SMALL'
                    ? SMALL_DESKTOP
                    : AnswerFontSize === 'LARGE'
                    ? LARGE_DESKTOP
                    : MEDIUM_DESKTOP,
                color: value === item.Option ? '#ffffff' : AnswerColorFill,
                cursor: 'pointer',
                marginTop: '2%'
              }}
              onClick={() => {
                if (isPractice && followTheFlow && isEmbeded) {
                  if (value === Options[Answers[0]].Option) {
                  } else {
                    if (completed === 0 && isActive && !explanationClick) {
                      handleOptionChange(item.Option)
                    }
                  }
                } else {
                  if (completed === 0 && isActive && !explanationClick) {
                    handleOptionChange(item.Option)
                  }
                }
              }}
            >
              {DisplayType === 'radioButton' && (
                <div
                  className='MCOptionNumber'
                  style={{
                    backgroundColor: isVerifyMode
                      ? item.Option === Options[Answers[0]].Option
                        ? '#3EC986'
                        : '#ff551f'
                      : isPractice || completed === 1 || !isActive
                      ? value === item.Option
                        ? value === Options[Answers[0]].Option
                          ? '#3EC986'
                          : '#ff551f'
                        : AnswerFillColor
                      : value === item.Option
                      ? SelectionColor
                      : AnswerFillColor
                  }}
                >
                  {ABCDE[index]}
                </div>
              )}
              <div
                className={
                  DisplayType === 'radioButton'
                    ? 'MCOptionItem'
                    : 'MCOptionItem MCOptionItemChat'
                }
                style={{
                  backgroundColor: isVerifyMode
                    ? item.Option === Options[Answers[0]].Option
                      ? '#3EC986'
                      : '#ff551f'
                    : isPractice || completed === 1 || !isActive
                    ? value === item.Option
                      ? value === Options[Answers[0]].Option
                        ? '#3EC986'
                        : '#ff551f'
                      : AnswerFillColor
                    : value === item.Option
                    ? SelectionColor
                    : AnswerFillColor,
                  justifyContent: TextAlign
                    ? TextAlign === 'left'
                      ? 'left'
                      : TextAlign === 'right'
                      ? 'right'
                      : 'center'
                    : 'left'
                }}
              >
                {AnswerType === 'inktotext' ? (
                  <InlineMath>{item.Option}</InlineMath>
                ) : (
                  <p
                    className='Text_align'
                    style={{
                      width: '100%',
                      margin: '0px',
                      fontFamily: FontStyle,
                      fontStyle: Italic === 'True' ? 'italic' : 'normal',
                      fontWeight: Bold === 'True' ? 'bold' : 'normal',
                      textAlign: TextAlign
                        ? TextAlign === 'left'
                          ? 'left'
                          : TextAlign === 'right'
                          ? 'right'
                          : 'center'
                        : 'left'
                    }}
                  >
                    {item.Option}
                  </p>
                )}
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default MultipleChoiceText
